const NextI18Next = require('next-i18next').default;
const config = require('../config/config');

const defaultLanguage = 'en';
const configLanguages = config.FRONTBASE_LANGUAGES || [];
const localeSubpaths = {};
// eslint-disable-next-line no-return-assign
configLanguages.forEach(language => (localeSubpaths[language] = language));
const otherLanguages = configLanguages.filter(language => language !== defaultLanguage);

const ignoreRoutes = [
  '/_next/',
  '/static/',
  '/public/',
  '/api/',
  '/images',
  '/locales',
  '/favicon.ico',
  '/build-info.txt',
  '/robots.txt',
  '/__nextjs',
];
const options = {
  defaultNS: 'translation',
  defaultLanguage,
  otherLanguages,
  localePath: 'public/locales',
  localeSubpaths,
  ignoreRoutes,
  keySeparator: '/', // to allow use keyes from oneSky like "some.some1.name"
  shallowRender: false,
};

const nextI18Next = new NextI18Next(options);

module.exports = {
  Trans: nextI18Next.Trans,
  Link: nextI18Next.Link,
  Router: nextI18Next.Router,
  i18n: nextI18Next.i18n,
  initPromise: nextI18Next.initPromise,
  config: nextI18Next.config,
  useTranslation: nextI18Next.useTranslation,
  withTranslation: nextI18Next.withTranslation,
  appWithTranslation: nextI18Next.appWithTranslation,
  ignoreRoutes,
};
